import React, { useState } from "react";
import { Modal } from "antd";
import {
  FormWrapperItem,
} from "../../../../../common/component/Index";
import Wrapper from "../../../../../common/component/Wrapper";
import { ListComponent } from './../../../../../common/component/Index';
import * as Func from '../../../../../../../helpers/functions';
import { Customer } from "../../../../../../../models/Order";
import { getMomentDate } from "../../../../../../../utils/commonUtils";
import { DATE_TIME_FORMAT, IDENTITYTYPE } from "../../../../../../../constants/Define";

let ListCols = ['fullName', 'email', 'dateOfBirth', 'phone', 'identityType', 'identityDetail', 'placeOfBirth'];
let ListRemoveCols = [];
const ModelFields = Object.getOwnPropertyNames(new Customer());

const CustomersModal = ({
  title = "",
  visible = false,
  items = [],
  onClose = () => {},
  t
}) => {

  const [titleItemTable] = useState(Func.getTitleTable(ListCols, [], ListRemoveCols));
  const [modelItem] = useState(ModelFields);
  const [componentTable] = useState({
    dateOfBirth: {
      render: (date) => getMomentDate(date).format(DATE_TIME_FORMAT.SHORT_DATE)
    },
    identityType: {
      render: (type) => IDENTITYTYPE.find(x=>x.key === type)?.label || ""
    }
  });

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose={true}
      width={"90%"}
    >
      <Wrapper className={`row mt-2`}>
        <FormWrapperItem classParent="p-0" classChildren="m-0 p-0">
          <ListComponent
            classParent="m-0 p-0 col-md-12"
            scroll={{ x: "auto" }}
            marginTop={"0"}
            marginBottom={"0"}
            rowKey={(record, k) => k}
            dataSource={Func.getDataSource(items || [], modelItem)}
            columns={Func.columnsTable({
              titleTable: titleItemTable,
              component: componentTable,
              itemName: "order",
            })}
            hideSettings={true}
            componentTableList={{}}
          />
        </FormWrapperItem>
      </Wrapper>
    </Modal>
  );
};

export default CustomersModal;
